import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../../lib/utils';

const spinnerVariants = cva(
  'inline-block shrink-0 animate-spin rounded-full border-2 border-border border-t-primary',
  {
    variants: {
      size: {
        sm: 'size-3.5',
        md: 'size-4',
        lg: 'size-6',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
);

export interface SpinnerProps
  extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof spinnerVariants> {}

const Spinner = forwardRef<HTMLSpanElement, SpinnerProps>(({ className, size, ...props }, ref) => (
  <span
    ref={ref}
    data-slot="spinner"
    role="status"
    aria-label="Loading"
    className={cn(spinnerVariants({ size }), className)}
    {...props}
  />
));
Spinner.displayName = 'Spinner';

export { Spinner, spinnerVariants };
